const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "G-P9BFN69M17";

export const isGaEnabled = () =>
  typeof window !== "undefined" &&
  typeof window.gtag === "function" &&
  GA_MEASUREMENT_ID;

const isLocalhost = () =>
  typeof window !== "undefined" && window.location.hostname === "localhost";

const withDebugMode = (params) =>
  isLocalhost() ? { ...params, debug_mode: true } : params;

export const trackPageView = (path, title) => {
  if (!isGaEnabled()) return;
  window.gtag(
    "event",
    "page_view",
    withDebugMode({
      page_path: path,
      page_title: title || document.title,
    })
  );
};

export const trackEvent = (name, params = {}) => {
  if (!isGaEnabled()) return;
  window.gtag("event", name, withDebugMode(params));
};

/**
 * GA4: user viewed the main deals list (/deals).
 * Register as a custom event in GA4 → Admin → Events; use Event count for reporting.
 */
export const trackDealsListView = (params = {}) => {
  trackEvent("view_deals_list", {
    page_path: "/deals",
    ...params,
  });
};

/**
 * GA4 custom dimension `area` on filter_applied — must never be null, undefined, or blank.
 */
export const gaFilterAreaParam = (area) => {
  if (area == null) return "all_areas";
  const s = String(area).trim();
  return s.length > 0 ? s : "all_areas";
};
